module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.appIsReady) ? _c('div', [_vm._v("Choose channel")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-246bbd84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 254
// module chunks = 2